import React, { PureComponent } from 'react';
import PT from 'prop-types';
import classNames from 'classnames';
import classes from './Matchup.css';

export default class Matchup extends PureComponent {
  static propTypes = {
    type: PT.string.isRequired,
  };

  render() {
    const { type } = this.props;

    const legendClass = classNames({
      good: type === 'good',
      bad: type === 'bad',
      neutral: type === 'neutral',
      [classes.matchup]: true,
    });

    return (
      <div className={legendClass}>
        <div>
          <div />
        </div>
        {`${type} Matchup`}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/TableControls/Matchup/Matchup.js